import Divider from 'components/common/Divider';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import paths from 'routes/paths';
import { useNavigate } from "react-router-dom";
import FileManagerGrid from './FileManagerGrid';
import DemoFileUpload from 'components/orderdetail/DemoFileUpload';
import axios from 'helpers/api';

const FileManager = ({ hasLabel, layout }) => {
    // State
    const [formData, setFormData] = useState({
        docUpload: '',
        docDescription: ''
    });
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const navigate = useNavigate();

    // Handler
    const handleSubmit = e => {
        e.preventDefault();
        let tokenStr = localStorage.getItem("accessToken");
        var payload = new FormData();
        const submittedData = {
            patient_id: localStorage.getItem("patientId"),
            docDescription: formData.docDescription,
        }
        if (uploadedFiles.length > 0) {
            uploadedFiles.forEach(file => {
                payload.append("documents", file, file.name);
            });
        }

        Object.keys(submittedData).forEach(key => {
            payload.append(key, submittedData[key]);
        });

        console.log("FormData", payload);

        const data = axios.post(`${process.env.REACT_APP_SERVER_URL}` + "/patients/file-manager", payload,
            { headers: { 'Authorization': `Bearer ${tokenStr}` } }
        )

        /*fetch(`${process.env.REACT_APP_SERVER_URL}`+"/users/login",
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'username': formData.username, 'password': formData.password })
          })
          .then(response => response.json())
          .then(function (data) {
            const items = data;
            console.log("Loginform " + items.status);
            if (items.status) {
              localStorage.setItem("accessToken", items.token);
              toast.success(`Logged in as ${formData.username}`, {
                theme: 'colored'
              });
              navigate("/main");
            }
            else {
              localStorage.setItem("hash", items.hash);
              toast.warning(`Email Needs to be verified ${formData.username}`, {
                theme: 'colored'
              });
              navigate("/otp");
            }
          })*/

    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleFileChange = (files) => {
        setUploadedFiles(files);
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Row className="align-items-center">
                <Col md={6}>
                    <Form.Group className="mb-3">
                        {/* <Form.Label>Upload Document</Form.Label> */}
                        <DemoFileUpload
                            onFilesChange={handleFileChange}
                            textOfDoc={'Upload Document'}
                        />
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Document Description</Form.Label>
                        <Form.Control
                            name="docDescription"
                            value={formData.docDescription}
                            onChange={handleFieldChange}
                            size="sm"
                            type="text"
                            placeholder="Enter description of the document"
                        />
                    </Form.Group>
                </Col>

                <Col md={12} className="text-center mb-4">
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-50 mt-3"
                            style={{
                                padding: '12px 24px',
                                borderRadius: '4px',
                                backgroundColor: '#007bff',
                                fontWeight: 'bold',
                                fontSize: '14px'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                        >
                            Upload
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FileManagerGrid />
                </Col>
            </Row>
        </Form>
    );
};

FileManager.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

FileManager.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default FileManager;

